import { useState } from "react";
import Pagination from "../component/Pagination";
import { FilterMenu, ProjectList } from "../utils/constant";
import ProjectItem from "../component/ProjectItem";

const RecentProjects = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentType, setCurrentType] = useState("All");

  const filterItem = (type) => {
    setCurrentType(type);
    setCurrentPage(1);
  };

  const filterData = () => {
    if (currentType === "All") {
      return ProjectList;
    } else return ProjectList.filter((item) => item.type === currentType);
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const itemPerPage = 3;
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = filterData().slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div id="portfolio">
      <div className="recentproject__header">My Portfolio</div>
      <div className="recentproject__summary">
        Here are my side projects. Want to see more? Email me!{" "}
        <a href="#email" className="recentproject__email">
          riaratnasari@outlook.com
        </a>
      </div>
      <div className="recentproject__menu row center-items">
        {FilterMenu.map((menu) => (
          <button
            key={menu.id}
            class={`btn ${
              currentType === menu.title
                ? "recentproject__selected"
                : "recentproject__not-selected"
            }`}
            name={menu.title}
            onClick={() => filterItem(menu.title)}
          >
            {menu.title}
          </button>
        ))}
      </div>

      <div className="center-items row">
        {currentItems.map((item) => (
          <ProjectItem item={item} />
        ))}
      </div>

      <Pagination
        itemPerPage={itemPerPage}
        totalItem={filterData().length}
        paginate={paginate}
        currentPage={currentPage}
      />

      <a
        href="https://github.com/riaars"
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-action-fill btn-radius"
      >
        <i className="fab fa-github space-right" aria-hidden="true"></i>
        <span>{"  "}See more on GitHub</span>
      </a>
    </div>
  );
};

export default RecentProjects;
